

















































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Button, FormItem, Input, Option, Select } from 'element-ui';

import { attachedDocumentOptions } from '@/constants/attachedDocumentOptions';
import { delegatedStepsOptions } from '@/constants/delegatedStepsOptions';
import { taxTypeOptions } from '@/constants/taxTypeOptions';

// type
import {
  DelegatedStepInput,
  ShipmentDocumentDataInput,
  ShipmentDocumentFields,
  TaxTypeEnumBase,
  TransportationCargoTypeEnum
} from '@/types/graphql/schemaTypes';

@Component({
  components: {
    'el-button': Button,
    'el-form-item': FormItem,
    'el-input': Input,
    'el-option': Option,
    'el-select': Select
  }
})
export default class RequestInformation extends Vue {
  @Prop({ type: Object }) value!: ShipmentDocumentDataInput;
  @Prop({ type: Object }) document!: ShipmentDocumentFields;

  readonly emptyStep: DelegatedStepInput = {
    delegatedStep: null,
    taxType: TaxTypeEnumBase.no_tax
  };

  readonly attachedDocumentOptions = attachedDocumentOptions();
  readonly delegatedStepsOptions = delegatedStepsOptions();
  readonly taxTypeOptions = taxTypeOptions();

  get attachedDocuments() {
    return [...this.value.attachedDocuments] || [];
  }

  set attachedDocuments(data) {
    this.$emit('input', { ...this.value, attachedDocuments: data });
  }

  get arrangementRemarks() {
    return this.value.arrangementRemarks;
  }

  set arrangementRemarks(data) {
    this.$emit('input', { ...this.value, arrangementRemarks: data });
  }

  get delegatedSteps() {
    return this.value.delegatedSteps?.length
      ? [...this.value.delegatedSteps]
      : [{ ...this.emptyStep }];
  }

  set delegatedSteps(data) {
    this.$emit('input', { ...this.value, delegatedSteps: data });
  }

  addStep() {
    this.$emit('input', {
      ...this.value,
      delegatedSteps: [...this.delegatedSteps, { ...this.emptyStep }]
    });
  }

  deleteStep(index: number) {
    // remove object from index
    this.delegatedSteps.splice(index, 1);
    // then emit it
    this.$emit('input', { ...this.value, delegatedSteps: this.delegatedSteps });
  }
}
